import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { ThemeProvider } from "@/context/ThemeContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import UpcomingEvents from "@/pages/UpcomingEvents";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import OpenPlay from "@/pages/OpenPlay";
import Settings from "@/pages/Settings";
import Profile from "@/pages/Profile";
import CompleteProfile from "@/pages/CompleteProfile";
import PlayerDirectory from "@/pages/PlayerDirectory";
import PlayerProfileView from "@/pages/PlayerProfileView";
import LiveView from "@/pages/LiveView";
import Admin from "@/pages/Admin";
import Tournaments from "@/pages/Tournaments";
import Subscribe from "@/pages/Subscribe";
import TournamentWizard from "@/pages/TournamentWizard";
import TournamentDetail from "@/pages/TournamentDetail";
import RegisterTournament from "@/pages/RegisterTournament";
import MyTournaments from "@/pages/MyTournaments";
import UmpireLogin from "@/pages/UmpireLogin";
import UmpireScore from "@/pages/UmpireScore";
import Spectator from "@/pages/Spectator";
import Scoreboard from "@/pages/Scoreboard";
import ClubWars from "@/pages/ClubWars";
import ClubWarsWizard from "@/pages/ClubWarsWizard";
import ClubWarDetail from "@/pages/ClubWarDetail";
import CaptainPortal from "@/pages/CaptainPortal";
import CwUmpireLogin from "@/pages/CwUmpireLogin";
import CwUmpireScore from "@/pages/CwUmpireScore";
import CwTvBoard from "@/pages/CwTvBoard";
import CwSchedule from "@/pages/CwSchedule";
import RatePlayer from "@/pages/RatePlayer";
import FindPlayers from "@/pages/FindPlayers";
import Inbox from "@/pages/Inbox";
import CasualSession from "@/pages/CasualSession";
import PlayerDatabase from "@/pages/PlayerDatabase";
import OrganizerRatings from "@/pages/OrganizerRatings";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/events" element={<UpcomingEvents />} />
      <Route path="/login" element={<Login />} />
      <Route path="/live/:token" element={<LiveView />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/open-play" element={<ProtectedRoute staff><OpenPlay /></ProtectedRoute>} />
      <Route path="/tournaments" element={<ProtectedRoute staff><Tournaments /></ProtectedRoute>} />
      <Route path="/subscribe" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
      <Route path="/tournaments/new" element={<ProtectedRoute staff><TournamentWizard /></ProtectedRoute>} />
      <Route path="/tournaments/:id" element={<ProtectedRoute staff><TournamentDetail /></ProtectedRoute>} />
      <Route path="/club-wars" element={<ProtectedRoute staff><ClubWars /></ProtectedRoute>} />
      <Route path="/club-wars/new" element={<ProtectedRoute staff><ClubWarsWizard /></ProtectedRoute>} />
      <Route path="/club-wars/:id" element={<ProtectedRoute staff><ClubWarDetail /></ProtectedRoute>} />
      <Route path="/club-wars/:id/edit" element={<ProtectedRoute staff><ClubWarsWizard /></ProtectedRoute>} />
      <Route path="/club-wars/:id/schedule" element={<ProtectedRoute staff><CwSchedule /></ProtectedRoute>} />
      <Route path="/cw/captain/:token" element={<CaptainPortal />} />
      <Route path="/cw/tv/:token" element={<CwTvBoard />} />
      <Route path="/cw-umpire" element={<CwUmpireLogin />} />
      <Route path="/cw-umpire/score" element={<CwUmpireScore />} />
      <Route path="/t/:tid" element={<ProtectedRoute><RegisterTournament /></ProtectedRoute>} />
      <Route path="/my-tournaments" element={<ProtectedRoute><MyTournaments /></ProtectedRoute>} />
      <Route path="/umpire" element={<UmpireLogin />} />
      <Route path="/umpire/score" element={<UmpireScore />} />
      <Route path="/spectator/:tid" element={<Spectator />} />
      <Route path="/scoreboard/:tid" element={<Scoreboard />} />
      <Route path="/complete-profile" element={<ProtectedRoute><CompleteProfile /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/players" element={<ProtectedRoute staff><PlayerDirectory /></ProtectedRoute>} />
      <Route path="/players/:userId" element={<ProtectedRoute><PlayerProfileView /></ProtectedRoute>} />
      <Route path="/rate/player/:token" element={<ProtectedRoute><RatePlayer /></ProtectedRoute>} />
      <Route path="/rate/:userId" element={<ProtectedRoute><RatePlayer /></ProtectedRoute>} />
      <Route path="/casual/:sid" element={<ProtectedRoute><CasualSession /></ProtectedRoute>} />
      <Route path="/find-players" element={<ProtectedRoute><FindPlayers /></ProtectedRoute>} />
      <Route path="/inbox" element={<ProtectedRoute><Inbox /></ProtectedRoute>} />
      <Route path="/player-database" element={<ProtectedRoute staff><PlayerDatabase /></ProtectedRoute>} />
      <Route path="/organizer/ratings" element={<ProtectedRoute staff><OrganizerRatings /></ProtectedRoute>} />
      <Route path="/signup" element={<Login />} />
      <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <Toaster position="top-center" richColors theme="system" />
            <AppRouter />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
